import { z } from 'zod';
import { bearer } from './http.js';
/**
 * Une ligne du journal telle que `GET /sync/logs` la rend — la ligne émise par la tablette,
 * plus ce que le serveur y a posé (`id`, `teamId`, `receivedAt`). `loose` et permissif : cet
 * export sert un CSV de diagnostic, pas un écran métier — refuser une ligne au champ inattendu
 * ferait perdre exactement ce qu'on est venu chercher.
 */
const storedClientLogSchema = z.looseObject({
    id: z.string(),
    teamId: z.string(),
    deviceId: z.string(),
    sessionId: z.string(),
    seq: z.number(),
    at: z.string(),
    receivedAt: z.string(),
    level: z.string(),
    tag: z.string(),
    event: z.string(),
    message: z.string(),
    detail: z.unknown().nullish(),
    inquiryId: z.string().nullish(),
    appBuild: z.string().nullish(),
});
/**
 * La lecture du journal des tablettes, réservée à l'administration — consommée par l'écran
 * d'outils temporaire (export CSV). L'expédition, elle, vit dans `sync.ts` : c'est la
 * tablette qui en dépend.
 */
export function createClientLogsEndpoints(http) {
    return {
        list(accessToken, limit) {
            const query = limit === undefined ? '' : `?limit=${String(limit)}`;
            return http.get(`/sync/logs${query}`, z.array(storedClientLogSchema), bearer(accessToken));
        },
    };
}
//# sourceMappingURL=client-logs.js.map